import { Component, OnInit } from '@angular/core';

import { AuthService } from './auth.service';

import { AngularFireDatabase, FirebaseListObservable } from 'angularfire2/database';
import { AngularFireAuth } from 'angularfire2/auth';
import { Observable } from 'rxjs/Observable';
import * as firebase from 'firebase/app';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  email: string;
  password: string;
  title = 'app';
  user: Observable<firebase.User>;
  items: FirebaseListObservable<any[]>;
  msgVal: string = '';

  constructor(public authService: AuthService, public afAuth: AngularFireAuth, public af: AngularFireDatabase) {
    this.user = this.afAuth.authState;
  }

  ngOnInit() {
    this.items = this.af.list('/messages', {
      query: {
        limitToLast: 50
      }
    });
  }


  signup() {
    this.authService.signup(this.email, this.password);
    this.email = this.password = '';
  }

  login() {
    this.authService.login(this.email, this.password);
    this.email = this.password = '';
  }

  logout() {
    this.authService.logout();
  }

  Send(desc: string) {
    this.items.push({ message: desc});
    this.msgVal = '';
  }
}



// WEBPACK FOOTER //
// /Users/danielcodrea/personal/Projects/HOW-TO_Project/how-to/src/app/app.component.ts